import * as v from 'valibot';

export const contractDocumentApiSchema = v.object({
  comment: v.nullish(v.string()),
  contractKey: v.string(),
  createdBy: v.number(),
  createdOn: v.string(),
  deletedBy: v.nullish(v.number()),
  deletedOn: v.nullish(v.string()),
  key: v.string(),
  modifiedBy: v.nullish(v.number()),
  modifiedOn: v.nullish(v.string()),
  name: v.string(),
  path: v.nullish(v.string()),
  type: v.nullish(v.string()),
});

export const contractDocumentsApiSchema = v.object({
  items: v.array(contractDocumentApiSchema),
  totalCount: v.number(),
});

export const contractDocumentItemSchema = v.object({
  comment: v.string(),
  createdOn: v.string(),
  id: v.string(),
  name: v.string(),
  type: v.string(),
});

export const contractDocumentsSchema = v.object({
  items: v.array(contractDocumentItemSchema),
  totalCount: v.number(),
});

export const contractDocumentsParamsSchema = v.object({
  comment: v.optional(v.string()),
  contractKey: v.string(),
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 5),
  name: v.optional(v.string()),
  offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  sorting: v.optional(v.string()),
  type: v.optional(v.string()),
});

export type ContractDocumentApi = v.InferOutput<typeof contractDocumentApiSchema>;
export type ContractDocumentsApi = v.InferOutput<typeof contractDocumentsApiSchema>;
export type ContractDocumentItem = v.InferOutput<typeof contractDocumentItemSchema>;
export type ContractDocuments = v.InferOutput<typeof contractDocumentsSchema>;
export type ContractDocumentsParams = v.InferOutput<typeof contractDocumentsParamsSchema>;
